import { cn } from "@/utils/cn";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function Toggle({
  checked,
  onChange,
  label,
  description,
  disabled,
}: ToggleProps) {
  return (
    <div
      onClick={() => !disabled && onChange(!checked)}
      className={cn(
        "flex items-start gap-3 cursor-pointer select-none",
        disabled && "opacity-50 pointer-events-none"
      )}
    >
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={(e) => {
          e.stopPropagation(); // prevent double toggle
          onChange(!checked);
        }}
        style={{
          padding: 0,
          border: "none",
          minHeight: "auto",
          width: "44px",
          height: "24px",
          display: "inline-block",
          position: "relative",
          boxSizing: "border-box",
          cursor: "pointer",
          borderRadius: "9999px",
          transition: "background-color 0.2s duration",
        }}
        className={cn(
          "shrink-0 focus:outline-none focus:ring-2 focus:ring-[#ff0000]/20",
          checked ? "bg-[#ff0000]" : "bg-gray-200"
        )}
      >
        <span
          style={{
            position: "absolute",
            top: "4px",
            left: checked ? "24px" : "4px",
            width: "16px",
            height: "16px",
            borderRadius: "9999px",
            backgroundColor: "#ffffff",
            transition: "left 0.2s ease",
            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
            display: "block",
          }}
        />
      </button>
      {(label || description) && (
        <div className="flex flex-col">
          {label && (
            <span className="text-sm font-medium text-gray-800">
              {label}
            </span>
          )}
          {description && (
            <span className="text-xs text-gray-500">
              {description}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
